<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <form @submit.prevent="saveProcessStep">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Edit process step') }}</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Process step details') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('Only color display and short description can be edited.') }}
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <span class="text-lg font-medium leading-6 text-gray-900">{{ processStep.name || '-' }}</span>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="short_description">{{ $t('Short description') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <textarea
                                            id="short_description"
                                            v-model="processStep.short_description"
                                            class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            rows="3"
                                        ></textarea>
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <input-color id="color" v-model="processStep.color" :label="$t('Color')" :placeholder="$t('Choose color')" required></input-color>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-100 px-4 py-3 sm:px-6 flex items-center justify-between">
                        <div class="text-xs text-gray-500">
                            Unique ID: {{ processStepUniqueId }}
                        </div>
                        <span class="inline-flex">
                            <router-link
                                class="btn btn-secondary shadow-sm rounded mr-4"
                                to="/workspace/admin/settings/process-steps"
                            >
                                {{ $t('Cancel') }}
                            </router-link>
                            <button
                                class="btn btn-gray shadow-sm rounded"
                                type="submit"
                            >
                                {{ $t('Save process step') }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
export default {
    name: "process-steps-edit",
    metaInfo() {
        return {
            title: this.$i18n.t('Edit process step')
        }
    },
    data() {
        return {
            loading: true,
            processStep: {
                name: null,
                short_description: null,
                value: null,
                system_value: null,
                process_step_category: null,
                color: '#2196F3',
            },
        }
    },
    computed: {
        processStepUniqueId() {
            if (this.processStep.system_value !== null && this.processStep.system_value !== undefined) {
                return this.processStep.system_value;
            }
            if (this.processStep.value !== null && this.processStep.value !== undefined) {
                return this.processStep.value;
            }
            return '-';
        },
    },
    mounted() {
        this.getProcessStep();
    },
    methods: {
        saveProcessStep() {
            const self = this;
            self.loading = true;
            const payload = {
                short_description: self.processStep.short_description,
                color: self.processStep.color,
            };
            axios.put('api/workspace/admin/process-steps/' + self.$route.params.id, payload).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getProcessStep() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/admin/process-steps/' + self.$route.params.id).then(function (response) {
                self.processStep = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}
</script>
